export const Section = ({ id, overline, title, sub, dark = false, className = "", children }) => (
  <section
    id={id}
    data-testid={id ? `section-${id}` : undefined}
    className={`relative py-20 sm:py-28 ${dark ? "bg-forest text-paper grain" : "bg-paper"} ${className}`}
  >
    <div className="relative mx-auto max-w-7xl px-5 sm:px-8">
      {overline && (
        <p className="text-xs sm:text-sm uppercase tracking-[0.22em] font-medium text-gold">
          {overline}
        </p>
      )}
      {title && (
        <h2
          className={`gold-rule mt-3 font-display text-3xl sm:text-4xl lg:text-5xl font-medium tracking-tight ${
            dark ? "text-paper" : "text-forest"
          }`}
        >
          {title}
        </h2>
      )}
      {sub && (
        <p className={`mt-8 max-w-2xl text-base leading-relaxed ${dark ? "text-paper/70" : "text-[#4A4C4A]"}`}>
          {sub}
        </p>
      )}
      <div className={title || overline ? "mt-12" : ""}>{children}</div>
    </div>
  </section>
);
